import { Box } from '@zoopla-eng/zds/box';
import { fontGroups } from '@zoopla-eng/zds/themes';
import { CmsImage } from '@zoopla/cms/image';
import { ReactElement } from 'react';
import { ArticlePublishedTime } from './ArticlePublishedTime';
import {
    articleSnippetTextStyle,
    cardContainerStyle,
    cardInfoStyle,
    customLinkStyle
} from './cms-article-card.styles.css';
import { articleTracking } from './cms-article-card.tracking';
import { ArticleCardProps, HeadingProps } from './cms-article-card.types';

function ArticleHeading({
    headingLevel,
    children
}: HeadingProps): ReactElement {
    if (headingLevel === 'h3') {
        return <h3 className={fontGroups.mug}>{children}</h3>;
    }

    return <h2 className={fontGroups.mug}>{children}</h2>;
}

function CmsArticleCard({
    article,
    index = 0,
    headingLevel = 'h2',
    linesToTruncate = 2,
    horizontalLayout = false,
    heroArticle = false,
    trackingFunction
}: ArticleCardProps) {
    return (
        <article
            data-testid={`recent-article-container-${index}`}
            className={cardContainerStyle({
                heroArticle,
                horizontal: horizontalLayout
            })}
        >
            <CmsImage
                data-testid={`recent-article-image-${index}`}
                src={`${article.heroImage?.url}`}
                width={800}
                loading="lazy"
                alt=""
                card
                heroArticle={heroArticle}
                horizontal={horizontalLayout}
            />
            <div
                className={cardInfoStyle({
                    heroArticle,
                    horizontal: horizontalLayout
                })}
            >
                <Box pb="S200">
                    <ArticleHeading headingLevel={headingLevel}>
                        <a
                            className={customLinkStyle}
                            href={`/discover/${article?.category?.slug ?? ''}/${
                                article?.slug
                            }/`}
                            data-testid={`recent-article-link-${index}`}
                            onClick={() =>
                                trackingFunction
                                    ? trackingFunction()
                                    : articleTracking(
                                          article?.slug ?? '',
                                          article?.category?.slug ?? '',
                                          index
                                      )
                            }
                        >
                            {article.title}
                        </a>
                    </ArticleHeading>
                </Box>
                <ArticlePublishedTime
                    dateTime={article.publicationDateAndTime}
                />
                <p
                    className={`${articleSnippetTextStyle({
                        lines: linesToTruncate
                    })} ${fontGroups.ladle}`}
                >
                    {article.snippet}
                </p>
            </div>
        </article>
    );
}

export default CmsArticleCard;
